<template>
  <div class="LegalPeopleInfo temr">
      <van-field
        readonly
        clickable
        v-model="col"
        :label="params.title"
        :placeholder="placeholder"
        right-icon="arrow"
        @click="showLocationPlacePicker = true"
      />
      <van-popup
        v-model="showLocationPlacePicker"
        position="bottom"
        :style="{ height: '40%' }"
      >
        <van-area
          :area-list="areaList"
          :value="value"
          @confirm="comfirmPlace"
          @cancel="showLocationPlacePicker = false"
        />
      </van-popup>
  </div>
</template>

<script>
import service from '@/request/api';
// 导入api接口
export default {
  name: 'LivingPlacePicker',
  props: ['params', 'placeholder', 'model'],
  data() {
    return {
      showLocationPlacePicker: false,
      areaList: {},
      value: '',
      col: '',
    };
  },
  mounted() {
    service.CommonForms.getAreaList()
      .then((res) => {
        this.areaList = res.data;
      })
      .catch((e) => {
      });
  },
  methods: {
    comfirmPlace(value) {
      this.showLocationPlacePicker = false;
      let temp = '';
      // if (!value) return;
      value.forEach((item) => {
        if (item) {
          temp += `${item.name || ''} `;
        }
      });
      if (value.slice(-1)[0]) {
        this.value = value.slice(-1)[0].code;
      } else {
        this.value = value[0].code;
      }
      this.col = temp;
      this.$emit('input', {
        value: this.value,
        name: temp,
      });
    },
  },
  watch: {
    'params.initValue': {
      handler(val) {
        if (val) {
          this.value = val.value;
          this.col = val.name;
        }
      },
    },
  },
};
</script>
<style scoped>
.bgColor {
  background: #f8f8f9;
}
.LegalPeopleInfo{
  position: relative;
}
.LegalPeopleInfo >>> .van-cell::after{
  border-bottom: 0px;
}
.line {
  width: 92%;
  height: 1px;
  margin: 0 auto;
  background: #efeff1;
  pointer-events: none;
}
>>> .van-field__label {
  text-align: left;
  color: #46494D;
  width: 86px;
  margin-right: 16px;
}
>>> .van-field__control::-webkit-input-placeholder {
  color: #BCC2CC;
  font-size: 16px;
}
>>> .van-field__control::-moz-input-placeholder {
  color: #BCC2CC;
  font-size: 16px;
}
>>> .van-field__control::-ms-input-placeholder {
  color: #BCC2CC;
  font-size: 16px;
}
.temr::after {
  position: absolute;
  right: 0;
  bottom: 0;
  left: 0;
  margin: 0 16px;
  box-sizing: border-box;
  border-bottom: 1px solid #dddee1;
  -webkit-transform: scaleY(0.5);
  transform: scaleY(0.5);
  content: ' ';
  pointer-events: none;
}
>>> .van-field__body{
  font-size: 16px;
}
</style>
